<template>
  <!--begin::Stats Widget 7-->
  <div class="card card-custom gutter-b">
    <!--begin::Body-->
    <div class="card-body d-flex flex-column p-0">
      <div
        class="d-flex align-items-center justify-content-between card-spacer flex-grow-1"
      >
        <div class="d-flex flex-column mr-2">
          <a
            href="#"
            class="text-dark-75 text-hover-primary font-weight-bolder font-size-h5"
          >
            Pagos recibidos
          </a>
          <span class="text-muted font-weight-bold mt-2">
            Por medio de pago
          </span>
        </div>
        <span class="symbol symbol-light-success symbol-45">
          <span class="symbol-label font-weight-bolder">
            {{data_series.total | currency}}
          </span>
        </span>
      </div>
      
      <apexchart
        class="card-rounded-bottom"
        :options="chartOptions"
        :series="series" 
        type="bar" height="450" 
      ></apexchart>
      <!--end::Chart-->
    </div>
    <!--end::Body-->
  </div>
  <!--end::Stats Widget 7-->
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "widget-7",
  props: ['data_series'],
  data() {
    console.log('metodos data '+ JSON.stringify(this.data_series));
    //Update chart
    return {
      loading:true,
      chartOptions: {xaxis:{categories: [""]}},
      series: [
        {
          name: "Total",
          data: [0]
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["layoutConfig"])
  },
  methods: {
    updateSeries() {
      const newData = this.series.data=this.data_series.montos;
      const colors = ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0']
      // Make sure to update the whole options config and not just a single property to allow the Vue watch catch the change.
      this.chartOptions = {
        xaxis: {categories: this.data_series.categorias},
        colors: [colors[Math.floor(Math.random()*colors.length)]]
      };
      // In the same way, update the series option
      this.series = [{
        data: newData
      }]      
    }
  },
  watch: {
    data_series: function() {
      console.log('data actualizada');
      this.updateSeries();
      this.loading=false;
      //   this.series[0].data[0] = _channel1;
    }
  },
  mounted() {
    // reference; kt_stats_widget_7_chart
    this.chartOptions = {
      chart: {
        type: "bar",
        height: 200,
        toolbar: {
          show: false
        }
      },
        zoom: {
          enabled: false
        },
      plotOptions: {
        bar: {
                horizontal: false,
              }
      },
      tooltip: {
        style: {
          fontSize: "12px",
          fontFamily: this.layoutConfig("font-family")
        },
        y: {
          formatter: function(val) {
            val = (val/1).toFixed(0).replace('.', ',')
            return "$"+val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
          }
        }
      },
      dataLabels: {
              enabled: false
            },
      xaxis: {
        name: "xx",
        categories: [""],//this.data_series.categorias,
      },
       colors: [this.layoutConfig("colors.theme.light.primary")]
      
    };
  }
};
</script>
